import { EmailRecipient } from '../components/messages/MessageList';

export function sortByProgramAndSeason(emailRecipients: EmailRecipient[]): EmailRecipient[] {
  return emailRecipients.slice().sort((a, b) => {
    if (a.programName === b.programName) {
      return a.seasonName > b.seasonName ? 1 : -1;
    }
    return a.programName > b.programName ? 1 : -1;
  });
}

export function getSortedDivisionsGroupedByProgramsSeasons(emailRecipients: EmailRecipient[]): {} {
  const sortedEmailRecipients = sortByProgramAndSeason(emailRecipients);
  const programGroups = sortedEmailRecipients.reduce((r, a) => {
    r[`${a.programName}: ${a.seasonName}`] = r[`${a.programName}: ${a.seasonName}`] || [];
    r[`${a.programName}: ${a.seasonName}`].push(a.divisionName);
    r[`${a.programName}: ${a.seasonName}`].sort();
    return r;
  }, {});
  return programGroups;
}
